import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'
import {SubsidiaryCategoryModel} from '../Model/SubsidiaryCategoryModel'
import { SortSubsidiaryCategoryActionModel, SortSubsidiaryCategoryModel } from '../Model'

function* getSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getSubsidiaryCategory, params)
    yield put(actions.getSubsidiaryCategorySuccess(response?.data?.data))
    yield put(actions.getSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getSubsidiaryCategoryFinish())
  }
}

function* getAllSubsidiaryCategorySaga() {
  try {
    const response: ResponseModel = yield call(service.getAllSubsidiaryCategory)
    yield put(actions.getAllSubsidiaryCategorySuccess(response?.data?.data))
    yield put(actions.getAllSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getAllSubsidiaryCategoryFinish())
  }
}

function* addSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addSubsidiaryCategory, body)
    yield put(actions.addSubsidiaryCategorySuccess(response.data?.data))
    yield put(actions.addSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addSubsidiaryCategoryFinish())
  }
}

function* enableSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableSubsidiaryCategory, selectedUsers)
    yield put(actions.enableSubsidiaryCategorySuccess(response?.data))
    yield put(actions.enableSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableSubsidiaryCategoryFinish())
  }
}

function* disableSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableSubsidiaryCategory, selectedUsers)
    yield put(actions.disableSubsidiaryCategorySuccess(response?.data))
    yield put(actions.disableSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableSubsidiaryCategoryFinish())
  }
}

function* singleEnableSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableSubsidiaryCategory, selectedUsers)
    yield put(actions.singleEnableSubsidiaryCategorySuccess(response?.data))
    yield put(actions.singleEnableSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleEnableSubsidiaryCategoryFinish())
  }
}

function* singleDisableSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableSubsidiaryCategory, selectedUsers)
    yield put(actions.singleDisableSubsidiaryCategorySuccess(response?.data))
    yield put(actions.singleDisableSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDisableSubsidiaryCategoryFinish())
  }
}

function* updateSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const body: SubsidiaryCategoryModel = action.payload
    const response: ResponseModel = yield call(
      service.updateSubsidiaryCategory,
      body,
      action.payload?.id
    )
    yield put(actions.updateSubsidiaryCategorySuccess(response.data?.data))
    yield put(actions.updateSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateSubsidiaryCategoryFinish())
  }
}

function* deleteSubsidiaryCategorySaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteSubsidiaryCategory, body)
    yield put(actions.deleteSubsidiaryCategorySuccess(response.data?.data))
    yield put(actions.deleteSubsidiaryCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteSubsidiaryCategoryFinish())
  }
}

function* sortSubsidiaryCategory(action: SortSubsidiaryCategoryActionModel) {
  try {
    const body: SortSubsidiaryCategoryModel = action.payload
    const response: ResponseModel = yield call(service.sortSubsidiaryCategory, body)

    yield put({
      type: actionTypes.SORT_SUBSIDIARY_CATEGORY_SUCCESS,
      payload: response?.data?.data,
    })
    yield put({type: actionTypes.SORT_SUBSIDIARY_CATEGORY_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SORT_SUBSIDIARY_CATEGORY_FINISH})
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_SUBSIDIARY_CATEGORY_START, getSubsidiaryCategorySaga)
  yield takeLatest(actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_START, getAllSubsidiaryCategorySaga)
  yield takeLatest(actionTypes.ADD_SUBSIDIARY_CATEGORY_START, addSubsidiaryCategorySaga)
  yield takeLatest(actionTypes.UPDATE_SUBSIDIARY_CATEGORY_START, updateSubsidiaryCategorySaga)
  yield takeLatest(actionTypes.DELETE_SUBSIDIARY_CATEGORY_START, deleteSubsidiaryCategorySaga)
  yield takeLatest(actionTypes.ENABLE_SUBSIDIARY_CATEGORY_REQUEST, enableSubsidiaryCategorySaga)
  yield takeLatest(actionTypes.DISABLE_SUBSIDIARY_CATEGORY_REQUEST, disableSubsidiaryCategorySaga)
  yield takeLatest(
    actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_REQUEST,
    singleEnableSubsidiaryCategorySaga
  )
  yield takeLatest(
    actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_REQUEST,
    singleDisableSubsidiaryCategorySaga
  )

  yield takeLatest(actionTypes.SORT_SUBSIDIARY_CATEGORY_START, sortSubsidiaryCategory)
}
